import React, { ReactNode } from 'react'
import { getTranslation } from 'utils/translations'
import { DocumentTooltipList } from '../components/DocumentTooltipList'
import { SIMPLE_TOOLTIP_KEYS } from './helpText'
import { DocumentCode } from './types'

export type DocumentTooltips = Partial<Record<DocumentCode, ReactNode>>

export const getDocumentTooltip = (code: DocumentCode) => {
  const simpleTooltips = SIMPLE_TOOLTIP_KEYS?.reduce((tooltipsObj, key) => {
    tooltipsObj[key] = getTranslation(`uploadDocuments.tooltip.${key}`)
    return tooltipsObj
  }, {} as DocumentTooltips)

  const tooltips: DocumentTooltips = {
    ...simpleTooltips,
    sourceOfFunds: (
      <DocumentTooltipList
        introduction={getTranslation('sourceOfFundsInfoBannerContentDescription')}
        list={[
          getTranslation('sourceOfFundsInfoBannerContentLine1'),
          getTranslation('sourceOfFundsInfoBannerContentLine2'),
          getTranslation('sourceOfFundsInfoBannerContentLine3'),
          getTranslation('sourceOfFundsInfoBannerContentLine4'),
        ]}
      />
    ),
    wolfsbergQuestionnaire: (
      <DocumentTooltipList
        introduction={`${getTranslation('uploadDocuments.tooltip.wolfsbergQuestionnaire.introduction')} ${getTranslation('uploadDocuments.tooltip.wolfsbergQuestionnaire.requirements')}`}
        list={[
          getTranslation('uploadDocuments.tooltip.wolfsbergQuestionnaire.riskProfile'),
          getTranslation('uploadDocuments.tooltip.wolfsbergQuestionnaire.globalLaws'),
          getTranslation('uploadDocuments.tooltip.wolfsbergQuestionnaire.businessRelationship'),
        ]}
      />
    ),
  }
  return tooltips?.[code] ?? null
}
